import React, { useContext } from "react";
import { Auth } from "../../rbac/rbac";
import { ROLE_OSC } from "../../utils/constants";
import NoteListView from "./notes-list-container";
import NoteButton from "../../components/note-button";
import AccordionView from "../../components/accordion/accordion";

/**
 * this component is used to render the notes section on details pages
 * @param {object} props component props
 * @param {string} type type of the customer
 */
const NoteReminderView = (props) => {
  const { user } = useContext(Auth);
  const { type } = props;
  const notesSource = props.data || props.customerData;
  const hasNotes = notesSource?.notes?.length > 0;
  const resolvedId = props.id || props.customerData?.id;
  const isOsc = user.role === ROLE_OSC || user.secondary_role === ROLE_OSC;

  return (
    <div className="mb-3 mt-md-3">
      <div className="d-flex justify-content-between mb-1">
        <h3 className="ml-0">
          Notes
        </h3>
        <NoteButton
          {...props}
          id={resolvedId}
          type={type}
          btnValue="ADD NOTE"
          function="CREATE"
          isOsc={isOsc}
        />
      </div>
      {!hasNotes && (
        <p
          style={{
            fontSize: "13px",
            color: "#6c757d",
            margin: "0.5rem 0",
          }}
        >
          No Notes Found
        </p>
      )}
      <div className="notes-list-row">
        <AccordionView
          component={NoteListView}
          data={notesSource}
          id={resolvedId}
          isDetailCard={false}
          type={type}
          {...props}
        />
      </div>
    </div>
  );
};

export default NoteReminderView;
